import { translate } from '@rhino-project/core/i18n';
export const VIDEO_SYSTEMS = [
  'forecheck',
  'backcheck',
  'breakout',
  'neutral_zone_offense',
  'neutral_zone_defense',
  'offensive_zone',
  'defensive_zone',
  'power_play',
  'penalty_kill',
  'faceoff',
  'transition',
  'goaltending',
  'skill'
] as const;
export type VideoSystem = (typeof VIDEO_SYSTEMS)[number];

export const formatVideoLabel = (s: string) =>
  translate(`rhino.generated.video.enums.system.${s}`, {
    defaultValue: s
      .split(/[-_\s]/)
      .filter(Boolean)
      .map((w) => w[0].toUpperCase() + w.slice(1))
      .join(' ')
  });
